import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'PARENT_STUDENT_GET',
  GET_SUCCESS: 'PARENT_STUDENT_GET_SUCCESS',
  GET_FAILURE: 'PARENT_STUDENT_GET_FAILURE',
};

export const get = actions.get(
  (id, query, meta) => `${BASE_URL}/students/v2/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
